<template>
  <section>
    <b-carousel
      :indicator-inside="false"
      pause-text="Pausado"
      :autoplay="autoplay"
      :interval="interval"
    >
      <b-carousel-item v-for="(image, i) in imgs" :key="i">
        <span class="image">
          <a @click.prevent="openModalImage( getFull(i) )" href="#">
            <media-img
              :img="getFull(i)"
              bgsize="contain"
              :size="size"
              :mobile_size="mobile_size"
              :zoomable="zoomable"
            />
          </a>
        </span>
      </b-carousel-item>
      <template #indicators="props">
        <media-img
          :img="getThumb(props.i)"
          bgsize="contain"
          size="80x80"
          mobile_size="80x80"
        />
      </template>
    </b-carousel>
    <b-modal v-model="isImageModalActive">
      <p class="image is-4by3">
        <img :src="modalCurrentImg" />
      </p>
    </b-modal>
  </section>
</template>

<script>
export default {
  
  name: "MediaCarousel",
  props: {
    images: Array,
    img_thumb: String,
    img_full: String,
    size: String,
    mobile_size: String,
    autoplay: {
      type: Boolean,
      default: false,
    },
    interval: {
      type: Number,
      default: 3500,
    },
    zoomable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      thumb: null,
      full: null,
      imgs: [],
      isImageModalActive: false,
      modalCurrentImg: '',
    };
  },

  created() {
    this.thumb = this.img_thumb;
    this.full = this.img_full;

    this.imgs = this.images;

    if (this.thumb && this.full) {
      this.imgs.unshift({
        thumb: this.thumb,
        full: this.full,
      });
    }

    console.log("Received Images Object", this.imgs);
  },

  methods: {

    openModalImage(src) {
      this.modalCurrentImg = src;
      this.isImageModalActive = true;
    },
    getFull(index) {
      return this.imgs[index].full;
    },
    getThumb(index) {
      return this.imgs[index].thumb;
    },
  },
};
</script>

<style lang="scss">
</style>